import { render, staticRenderFns } from "./SetTypeDialog.vue?vue&type=template&id=f8ec41ea&scoped=true"
import script from "./SetTypeDialog.vue?vue&type=script&lang=js"
export * from "./SetTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./SetTypeDialog.vue?vue&type=style&index=0&id=f8ec41ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ec41ea",
  null
  
)

export default component.exports